module.exports = __webpack_public_path__ + "img/logo-tabuleo.65ec2b06.png";